module.exports = __webpack_public_path__ + "img/thunderstorm.ed4effe6.svg";